// ----------------------------------------------------------------------------
// Component: Image Gallery
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import Swiper, { Navigation, Thumbs, A11y, Keyboard } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// Styles
import './_image-gallery.scss';

const GALLERY_SECTION_SELECTOR = '.carousel-section--image-gallery';
const MAIN_SELECTOR = '.image-gallery__main';
const THUMBS_SELECTOR = '.image-gallery__thumbs';

document.querySelectorAll(GALLERY_SECTION_SELECTOR).forEach((element, index) => {
    const mainEl = element.querySelector(MAIN_SELECTOR);
    const thumbsEl = element.querySelector(THUMBS_SELECTOR);
    const nextBtn = mainEl.querySelector('.swiper-button-next');
    const prevBtn = mainEl.querySelector('.swiper-button-prev');

    // Add unique classes
    mainEl.classList.add(`image-gallery-main-${index}`);
    thumbsEl.classList.add(`image-gallery-thumbs-${index}`);
    nextBtn.classList.add(`image-gallery-btn-next-${index}`);
    prevBtn.classList.add(`image-gallery-btn-prev-${index}`);

    // Init thumbnails swiper
    const thumbsSwiper = new Swiper(`.image-gallery-thumbs-${index}`, {
        modules: [Thumbs, Keyboard, A11y],
        a11y: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesProgress: false,
    });

    // Init main swiper with thumbs control
    new Swiper(`.image-gallery-main-${index}`, {
        modules: [Navigation, Thumbs, Keyboard, A11y],
        a11y: true,
        spaceBetween: 10,
        navigation: {
            nextEl: `.image-gallery-btn-next-${index}`,
            prevEl: `.image-gallery-btn-prev-${index}`,
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
    });
});
